// Average reading speed of an adult. Consistent with what's on the site, see
// https://github.com/axioscode/platform-api-content/blob/master/render/serializers.py#L443,
// which is most likely based on
// https://help.medium.com/hc/en-us/articles/214991667-Read-time
const WPM = 265;

export default function calculateReadingTime(wordCount) {
  // if estimated time is less than 30 seconds
  if (wordCount * 2 <= WPM) return "<1";

  return Math.round(wordCount / WPM);
}
